import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  border?: boolean
  small?: boolean
  secondary?: boolean
  tertiary?: boolean
  icon?: string
  disabled?: boolean
  height?: number
  isAccessPage?: boolean
  xsmall?: boolean
  big?: boolean
  orange?: boolean
}

const Button = styled.button<IStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => (props.height ? `${props.height}px` : '40px')};
  width: ${(props: IStyleProps) => {
    if (props.icon && props.small) return '180px'
    if (props.small) return '120px'
    return '252px'
  }};
  font-size: 12px;

  font-family: ${Theme.fontFamily.SECONDARY};

  cursor: pointer;
  font-style: normal;
  font-weight: 700;
  border-radius: 5px;

  background-color: ${(props) => {
    if (props.orange) return '#E07A58'
    if (props.isAccessPage) return props.theme.colors.pageBg
    return props.theme.colors.primary
  }};

  color: ${(props) =>
    props.isAccessPage
      ? props.theme.colors.primary
      : props.theme.colors.primaryBtnTxt};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryHover};
  }
  &:hover {
    background: ${(props: IStyleProps) => {
      if (props.orange) return '#D97254'
      if (props.secondary) return '#757575'
      if (props.tertiary) return '#757575'
      return '#757575'
    }};
  }

  &:disabled {
    background: '#D97254';
    border: none;
    cursor: not-allowed;
  }

  .default-btn-img {
    max-width: 14px;
    max-height: 14px;
    margin-right: 5px;

    width: ${(props: IStyleProps) => {
      if (props.icon && props.small) return '180px'
      if (props.small) return '120px'
      if (props.xsmall) return '160px'
      if (props.big) return '315px'
      return '252px'
    }};

    filter: ${({ theme }) => theme.filters.primaryIcon};
  }

  @keyframes load {
    to {
      transform: rotate(360deg);
    }
  }
  .loading-img-button {
    width: 18px;
    height: 18px;
    animation: load 2s infinite linear;
    border-radius: 15%;
  }

  @media only screen and (min-width: 1441px) {
    height: 45px;
    width: ${(props: IStyleProps) => {
      if (props.icon && props.small) return '180px'
      if (props.small) return '135px'
      return '284px'
    }};
    font-size: 13px;
  }
  border: none;
`
export default Button
